// Components/Custom/BenefitsModal.tsx
import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

interface BenefitsModalProps {
  isOpen: boolean;
  onCancel: () => void;
}

const BenefitsModal: React.FC<BenefitsModalProps> = ({ isOpen, onCancel }) => {
  const benefits = [
    "Web & Mobile Platforms",
    "Unlimited quotes & invoices",
    "Manage up to 100 clients & jobs",
    "Custom branding",
    "Reports & Insights",
    "Priority customer support",
  ];

  return (
    <Modal
      isOpen={isOpen}
      toggle={onCancel}
      centered
      size="sm"
      backdrop="static"
    >
      <ModalHeader toggle={onCancel} className="bg-greyF5 p-3 pe-4 ps-4">
        <span className="text-black2D fs-16 fw-medium font-primary">
          Benefits
        </span>
      </ModalHeader>

      <ModalBody className="pt-4 pb-0">
        <ul className="list-unstyled vstack gap-1">
          {benefits.map((benefit, index) => (
            <li key={index} className="d-flex align-items-start">
              <i className="ri-check-line text-success fs-18 me-3 flex-shrink-0 " />
              <span className="text-dark fs-14 fw-normal font-primary">
                {benefit}
              </span>
            </li>
          ))}
        </ul>
      </ModalBody>
    </Modal>
  );
};

export default BenefitsModal;
